import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  PagingOptions,
  ConfigResetId,
  ConfigResetActionId,
  QueryResultDTO,
  ConfigResetActionLogDTO,
  ConfigResetDTO,
  ConfigResetSummaryDTO,
  RestoreTaskId,
  ConfigResetListDTO,
} from '../../shared/models/backups.models';

@Injectable({
  providedIn: 'root',
})
export class ConfigResetService {
  baseURL = '/config-orchestrator';

  private http = inject(HttpClient);

  deleteConfigResetActionLog(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseURL}/logs/${id}`);
  }

  searchConfigResetActionLogs(
    query: PagingOptions,
  ): Observable<QueryResultDTO<ConfigResetActionLogDTO>> {
    const params = new HttpParams().set('page', query.page).set('pageSize', query.pageSize);

    return this.http
      .get<[ConfigResetActionLogDTO[], number]>(`${this.baseURL}/logs`, { params })
      .pipe(map(([data, total]) => ({ data, total })));
  }

  getConfigReset(id: ConfigResetId): Observable<ConfigResetDTO> {
    return this.http.get<ConfigResetDTO>(`${this.baseURL}/config-restore/configs/${id}`);
  }

  getConfigResetByTask(id: RestoreTaskId): Observable<ConfigResetListDTO> {
    return this.http.get<ConfigResetListDTO>(`${this.baseURL}/config-restore/configs/task/${id}`);
  }

  searchConfigResets(query: PagingOptions): Observable<QueryResultDTO<ConfigResetSummaryDTO>> {
    const params = new HttpParams().set('page', query.page).set('pageSize', query.pageSize);

    return this.http
      .get<[ConfigResetSummaryDTO[], number]>(`${this.baseURL}/config-restore/configs`, {
        params,
      })
      .pipe(map(([data, total]) => ({ data, total })));
  }

  deleteConfigReset(id: ConfigResetId): Observable<void> {
    return this.http.delete<void>(`${this.baseURL}/config-restore/configs/${id}`);
  }

  deleteConfigResetAction(id: ConfigResetActionId): Observable<void> {
    // Implementing the method in the old version returns only Error
    return this.http.delete<void>(`${this.baseURL}/config-reset-action/${id}`);
  }
}
